import styled from 'styled-components';

interface FjFlexContainerProps {
  flex?: string;
  direction?: string;
}

const FjFlexContainer = styled('div')<FjFlexContainerProps>`
  flex: ${(props) => props.flex || '1'};
  display: flex;
  flex-direction: ${(props) => props.direction || 'row'};
  min-width: 0;
  min-height: 0;
`;

export default FjFlexContainer;
